import { render, staticRenderFns } from "./upload-case-history.vue?vue&type=template&id=0670a658&"
import script from "./upload-case-history.vue?vue&type=script&lang=js&"
export * from "./upload-case-history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports